import components from './components'
import constant from '~/locales/en/const'
export default {
  components,
  constant,
}
